/* eslint-disable */
import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { observer } from 'mobx-react';

// 空白間距.
function Spacer() {
  return <div className={css(styles.flex_spacer)} />;
}

// icon.
function IconCircle() {
  return (
    <div className={css(styles.flex_item)}>
      <div
        style={{
          '--src': `url(${
            require('assets/d5c2455d5a7ee14fe32d583081ece7cb.svg').default
          })`
        }}
        className={css(styles.cover_group, styles.cover_group_layout)}
      >
        <div
          style={{
            '--src': `url(${
              require('assets/485d058447dfb7d78dc816201c2eb0c8.png').default
            })`
          }}
          className={css(styles.image, styles.image_layout)}
        />
      </div>
    </div>
  );
}

// 填滿.
function FillCircle(props) {
  const { index } = props;

  return (
    <div className={css(styles.flex_item)}>
      <div
        style={{
          '--src': `url(${
            require('assets/a9c112b702a1449d7229541474ae1d7b.svg').default
          })`
        }}
        className={css(styles.cover_group, styles.cover_group_layout)}
      >
        <h5 className={css(styles.highlights, styles.highlights_layout)}>
          {index}
        </h5>
      </div>
    </div>
  );
}

// 未填滿.
function NotFillCircle(props) {
  const { index } = props;

  return (
    <div className={css(styles.flex_item)}>
      <div
        style={{
          '--src': `url(${
            require('assets/5f87063df2fc7169fed6fe720363a685.svg').default
          })`
        }}
        className={css(styles.cover_group, styles.cover_group_layout)}
      >
        <h5 className={css(styles.highlights2, styles.highlights2_layout)}>
          {index}
        </h5>
      </div>
    </div>
  );
}

@observer
class Indexes extends React.Component {
  render() {
    const { type, questions, index } = this.props;

    if (type === 'home') {
      const arr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

      return (
        <div className={`indexes ${css(styles.flex, styles.flex_layout)}`}>
          {arr.map((el) => {
            if (el === 0) {
              return (
                <>
                  <IconCircle />
                  <Spacer />
                </>
              );
            } else {
              return (
                <>
                  <NotFillCircle index={el} />
                  <Spacer />
                </>
              );
            }
          })}
        </div>
      );
    }

    return (
      <div className={`indexes ${css(styles.flex, styles.flex_layout)}`}>
        <FillCircle index={0} />

        <Spacer />

        {questions.map((el, i, arr) => {
          let tag = null;

          if (i < index) {
            tag = <FillCircle index={i + 1} />;
          } else if (i > index) {
            tag = <NotFillCircle index={i + 1} />;
          } else {
            tag = <IconCircle />;
          }

          return (
            <>
              {tag}
              {i !== arr.length - 1 && <Spacer />}
            </>
          );
        })}
      </div>
    );
  }
}

export default Indexes;

Indexes.inStorybook = true;

const styles = StyleSheet.create({
  flex: {
    display: 'flex'
  },
  flex_layout: {
    position: 'relative',
    flexGrow: 1,
    '@media (max-width: 991.98px)': {
      margin: 0
    }
  },
  flex_item: {
    display: 'flex',
    flex: '0 1 30px'
  },
  cover_group: {
    display: 'flex',
    background: 'var(--src) center center / 100% 100% no-repeat'
  },
  cover_group_layout: {
    position: 'relative',
    minHeight: 30,
    flexGrow: 1
  },
  highlights: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '500 16px/1.5 "Roboto", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px',
    '@media (max-width: 767.98px)': {
      fontSize: '14px',
      textAlign: 'center'
    }
  },
  highlights_layout: {
    width: 14,
    minWidth: 14,
    margin: '3px auto'
  },
  flex_spacer: {
    flex: '0 1 16px'
  },
  cover_group1: {
    display: 'flex',
    background: 'var(--src) center center / contain no-repeat'
  },
  cover_group1_layout: {
    position: 'relative',
    minHeight: 30,
    flexGrow: 1
  },
  cover_group: {
    display: 'flex',
    background: 'var(--src) center center / 100% 100% no-repeat'
  },
  image: {
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  image_layout: {
    minHeight: 20,
    width: '43.33%',
    minWidth: 'min-content',
    margin: '6px auto 4px'
  },
  cover_group: {
    display: 'flex',
    background: 'var(--src) center center / 100% 100% no-repeat'
  },
  highlights2: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '16px/1.5 Roboto, Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px',
    '@media (max-width: 767.98px)': {
      fontSize: '14px',
      textAlign: 'center'
    }
  },
  highlights2_layout: {
    width: 13,
    minWidth: 13,
    margin: '3px auto'
  },
  cover_group: {
    display: 'flex',
    background: 'var(--src) center center / 100% 100% no-repeat'
  },
  highlights3: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '16px/1.5 Roboto, Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px',
    '@media (max-width: 767.98px)': {
      fontSize: '14px',
      textAlign: 'center'
    }
  },
  highlights3_layout: {
    width: 13,
    minWidth: 13,
    margin: '3px auto'
  },
  cover_group: {
    display: 'flex',
    background: 'var(--src) center center / 100% 100% no-repeat'
  },
  highlights4: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '16px/1.5 Roboto, Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px',
    '@media (max-width: 767.98px)': {
      fontSize: '14px',
      textAlign: 'center'
    }
  },
  highlights4_layout: {
    width: 13,
    minWidth: 13,
    margin: '3px auto'
  },
  cover_group: {
    display: 'flex',
    background: 'var(--src) center center / 100% 100% no-repeat'
  },
  highlights5: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '16px/1.5 Roboto, Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px',
    '@media (max-width: 767.98px)': {
      fontSize: '14px',
      textAlign: 'center'
    }
  },
  highlights5_layout: {
    width: 13,
    minWidth: 13,
    margin: '3px auto'
  },
  cover_group: {
    display: 'flex',
    background: 'var(--src) center center / 100% 100% no-repeat'
  },
  highlights6: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '16px/1.5 Roboto, Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px',
    '@media (max-width: 767.98px)': {
      fontSize: '14px',
      textAlign: 'center'
    }
  },
  highlights6_layout: {
    width: 13,
    minWidth: 13,
    margin: '3px auto'
  },
  cover_group: {
    display: 'flex',
    background: 'var(--src) center center / 100% 100% no-repeat'
  },
  highlights7: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '16px/1.5 Roboto, Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px',
    '@media (max-width: 767.98px)': {
      fontSize: '14px',
      textAlign: 'center'
    }
  },
  highlights7_layout: {
    width: 13,
    minWidth: 13,
    margin: '3px auto'
  },
  cover_group: {
    display: 'flex',
    background: 'var(--src) center center / 100% 100% no-repeat'
  },
  highlights8: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '16px/1.5 Roboto, Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px',
    '@media (max-width: 767.98px)': {
      fontSize: '14px',
      textAlign: 'center'
    }
  },
  highlights8_layout: {
    width: 13,
    minWidth: 13,
    margin: '3px auto'
  },
  cover_group_layout9: {
    position: 'relative',
    flexGrow: 1
  },
  cover_group: {
    display: 'flex',
    background: 'var(--src) center center / 100% 100% no-repeat'
  },
  highlights9: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '16px/1.5 Roboto, Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px',
    '@media (max-width: 767.98px)': {
      fontSize: '14px',
      textAlign: 'center'
    }
  },
  highlights9_layout: {
    width: '73.33%',
    minWidth: 'min-content',
    margin: '3px auto'
  }
});
